import Loading from "@/components/Loading";
import { useMediaQuery } from "@/lib/hooks/useMediaQuery";
import { useStytchSession, useStytchUser } from "@stytch/react";
import { Outlet } from "react-router-dom";
import MobileNav from "./navigation/MobileNav";
import DesktopNav from "./navigation/DesktopNav";
import EmailVerification from "@/components/EmailVerification";
import ScrollToTop from "@/components/scroll/ScrololToTop";

function CheckoutLayout({ children }: { children?: React.ReactNode }) {
  const { session, fromCache: sessionFromCache } = useStytchSession();
  const { user, fromCache: userFromCache } = useStytchUser();
  const isDesktop = useMediaQuery("(min-width: 768px)");
  if (session) {
    const authFactors = session.authentication_factors || [];

    if (authFactors.length === 1) {
      if (authFactors[0].type === "password" && !user?.emails[0].verified) {
        if (!user?.emails[0].email) {
          return <Loading />;
        }

        return (
          <>
            {!isDesktop && <MobileNav />}
            {isDesktop && <DesktopNav />}
            {children}
            <EmailVerification />
          </>
        );
      }
    }
  }

  if (userFromCache && sessionFromCache) {
    return <Loading />;
  }

  return (
    <div className="flex flex-col w-full min-h-dvh md:flex-row">
      {isDesktop && (
        <div className="hidden md:block md:shrink-0 md:h-dvh md:sticky top-0 w-[70px] border-r border-border">
          <DesktopNav />
        </div>
      )}
      <div className="flex flex-col flex-1 min-w-0 min-h-dvh">
        <ScrollToTop />
        {!isDesktop && <MobileNav />}
        {children}
        <Outlet />
      </div>
    </div>
  );
}

export default CheckoutLayout;
